export default __webpack_public_path__ + "static/Kaye-64093b780fda6035c0ac3c1161e2f8fc.jpg";